import { Box, Button, Card, CardActions, CardContent, CircularProgress, Typography } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import EditIcon from '@mui/icons-material/Edit'
import React, { useContext, useEffect, useState } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import MapMarker from './MapMarker'
import { getCenterById } from '../../services/form/center'
import { Context } from '../../contexts/Context'

export default function ViewCenter ({ token }) {
  const { handleToken } = useContext(Context)
  const { id } = useParams()
  const [centerDetails, setcenterDetails] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    getCenterById(id, token)
      .then(res => {
        if (res.status === 'Unauthorized') {
          handleToken(null)
          navigate('/login')
        } else setcenterDetails(res)
      })
    // eslint-disable-next-line
  }, [])

  return (
    <>
      {centerDetails
        ? <Card sx={{ paddingBottom: '5px', margin: ' 0 auto', maxWidth: '800px' }}>
          <CardContent>
            <Typography size='sm' gutterBottom variant='h5' component='div'>
              {centerDetails.centerName}
            </Typography>
            <Typography sx={{ padding: '5px', margin: '5px auto', background: '#F2F2F2' }} variant='body1' color='text.secondary'>
              Address : {(centerDetails?.address?.address1 || '') + ' ' + (centerDetails?.address?.address2 || '') + ' ' + (centerDetails?.address?.city || '') + ' ' + (centerDetails?.address?.state || '') + ' ' + (centerDetails?.address?.pin || '')}
            </Typography>
            <Typography sx={{ margin: '5px auto' }} variant='body1' color='text.secondary'>
              Contact : {centerDetails?.contact || 'NA'}
            </Typography>
            <Typography sx={{ padding: '5px', margin: '5px auto', background: '#F2F2F2' }} variant='body1' color='text.secondary'>
              Working Hours : {centerDetails.workingHours?.start && centerDetails.workingHours?.end ? centerDetails.workingHours?.start + ' to ' + centerDetails.workingHours?.end : 'NA'}
            </Typography>
          </CardContent>

          <CardContent sx={{ py: '0px' }}>
            <Typography sx={{ margin: '0 auto 5px' }} level='h4' color='text.primary'>
              Latitude : {(centerDetails?.location?.coordinates[1] || 'NA') + ' ,  Longitude : ' + (centerDetails?.location?.coordinates[0] || 'NA')}
            </Typography>
            {centerDetails.location && <MapMarker location={centerDetails?.location} />}
          </CardContent>

          <CardActions sx={{ display: 'flex', justifyContent: 'space-around' }}>
            <Link to='/centers'>
              <Button variant='outlined' id='back' size='small'>
                <ArrowBackIosIcon sx={{ width: '15px', pr: '3px' }} />
                Back
              </Button>
            </Link>
            <Link to={'/center/' + id + '/edit'}>
              <Button color='primary' variant='contained' size='small'>
                <EditIcon sx={{ width: '15px', pr: '3px' }} />
                Edit
              </Button>
            </Link>
          </CardActions>

        </Card>
        : <Box sx={{ display: 'flex' }}>
          <CircularProgress sx={{ margin: '20vh auto ' }} />
        </Box>}
    </>
  )
}
